<template>
  <v-container
    v-if="user?.role?.id == roleIds.admin || user.acessoIntegracoes"
    fluid
    class="pa-5"
  >
    <br />
    <h1>Integrações</h1>
    <br />
    <!-- ADMIN -->
    <v-container fluid>
      <v-tabs color="primary accent-4" active-class="primary white--text">
        <v-tab style="background-color: lightgray"
          >Lançamentos Contábeis Folha de Pagamento</v-tab
        >

        <v-tab style="background-color: lightgray"
          >Lançamentos Contábeis Despesas Financeiras</v-tab
        >

        <v-tab-item class="pa-10">
          <Integration1></Integration1>
        </v-tab-item>
        <v-tab-item><Integration2></Integration2></v-tab-item>
      </v-tabs>
    </v-container>
  </v-container>
  <v-container v-else>
    <p>Acesso não autorizado</p>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import roleIds from "../../../../libraries/strapi/rolesIds";
import DateInputDate from "../../components/fields/DateInputDate";
import DateInput from "../../components/fields/DateInput";
import Integration1 from "./Integration1.vue";
import Integration2 from "./Integration2.vue";

export default {
  name: "Integrations",
  props: ["priCod"],
  components: { DateInputDate, DateInput, Integration1, Integration2 },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    filCod() {
      return this.$route.query.filCod;
    },
  },
  data() {
    return {
      roleIds: roleIds,
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped>
.tabActive {
  background-color: #3e8ac7;
}

.holds-the-iframe {
  background: url("https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif")
    center center no-repeat;
}

.custom-table .v-data-table__wrapper {
  border: none;
}

.custom-table .v-data-table__thead > tr > th:not(:last-child),
.custom-table .v-data-table__tbody > tr > td:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 1) !important;
}
</style>
